import { combineReducers } from 'redux'
import { VideoCallsAppState } from 'components/features/videoCalls/types/state'
import { videoCallDetailsReducer } from 'components/features/videoCalls/reducers/videoCallDetailsReducer'
import { peersReducer } from 'components/features/videoCalls/reducers/peersReducer'
import { clientReducer } from 'components/features/videoCalls/reducers/clientReducer'
import { localStreamReducer } from 'components/features/videoCalls/reducers/localStreamReducer'
import { screenStreamReducer } from 'components/features/videoCalls/reducers/screenStreamReducer'
import { permissionsReducer } from 'components/features/videoCalls/reducers/permissionsReducer'

export const videoCallReducer = combineReducers<VideoCallsAppState>({
  details: videoCallDetailsReducer,
  peers: peersReducer,
  client: clientReducer,
  localStream: localStreamReducer,
  screenStream: screenStreamReducer,
  permissions: permissionsReducer,
})
